// @flow
import { resourceFetch } from 'app/common/redux/actions/resourceFetch';
import type { Action, State } from 'app/common/redux/types';
import type { Dispatch, MiddlewareAPI } from 'redux';

// $FlowFixMe: New error after Flow Upgrade http://pinch.pinadmin.com/flow53upgdoc
export default (store: MiddlewareAPI) => (next: Dispatch<any>) => (action: Action): State => {
  const { username } = store.getState().viewer;
  if (action.type === 'BOARDS_FETCH_ALL_IF_NEEDED') {
    const boards = store.getState().boards;
    if (!(boards && boards.fetchAllComplete) && username) {
      store.dispatch(
        resourceFetch('BoardsResource', {
          username,
          field_set_key: 'board_picker_react',
        }),
      );
    }
  } else if (action.type === 'BOARDS_FETCH_LAST_PINNED_TO_IF_NEEDED') {
    const boards = store.getState().boards;
    if (!(boards && boards.lastPinnedTo)) {
      store.dispatch(
        resourceFetch('BoardPickerBoardsShortlistResource', {
          num_shortlist_suggestions: 0,
          shortlist_length: 3,
        }),
      );
    }
  }

  return next(action);
};
